module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/star.svg?828883c39beeb366cc89194dbd41fbf6";